module.exports = __webpack_public_path__ + "static/media/jonathan.134492d5.jpg";